import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, LazyImage, MainHeading, SpanStyled, SpanStyledB } from '../../ui/Elements'

import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { Animate } from 'react-simple-animate'
import { PrimaryHeading } from '../../ui/Elements'
import { OurProjectBg, OurTeamIcon1, OurTeamIcon2, OurTeamIcon3, OurTeamIcon4, OurTeamIcon5, OutTeamBg, ProjImg1, ProjImg2, ProjImg3, ProjImg4, ProjImg5, ProjImg6, ProjImg7, ProjImg8 } from '../../ui/AllImages'
const Team = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // run animation once
                }
            },
            {
                threshold: 0.2, // 20% of section visible triggers the animation
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);
    
    const start = i18n.language === "ar"
    ? { clipPath: "inset(0 0 0 100%)" }   // Arabic → reveal right → left
    : { clipPath: "inset(0 100% 0 0)" };  // English → reveal left → right
    const end = { clipPath: "inset(0 0% 0 0)" };
    const start2 = { opacity: 0, transform: 'translateY(-20px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    const start3 = { opacity: 0, transform: 'translateY(0px)' };
    const end3 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <>
            <TeamWapper className='container-fluid common-space transformFluid' id='ourTeam' ref={sectionRef}>
                <Container>
                    <Box className='servicesRow row'>

                        <Col md={12} className="servicesColMain">
                            <Row className=''>
                                <Col md={12}>
                                <Animate
                                                                                    play={isVisible}
                                                                                    duration={1.5}
                                                                                    delay={-1}
                                                                                    
                                                        
                                                                                    start={start}
                                                                                    end={end}
                                                                                >
                                    <PrimaryHeading className='main-heading mb-5 primary-heading' color="var(--white)">
                                        {t('teamTitle')}
                                    </PrimaryHeading>
                                    </Animate>
                                    <Col md={12} className='about-h-row'>
                                    <Animate
                                                                                            play={isVisible}
                                                                                            duration={1}
                                                                                            delay={.8}
                                                                                            start={start2}
                                                                                            end={end2}
                                                                                        >
                                        <MainHeading className='main-heading mb-3 main-heading-about' size="40px">
                                            <SpanStyled className='servicesT1' color='var(--white)'>{t('teamTxt')}</SpanStyled> 
                                        </MainHeading>
                                        </Animate>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>



                        <Col md={12} className=''>
                            <Row className=''>
                                <Col className='servBoxCol'>
                                <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={1.2}
                                                                            start={start3}
                                                                            end={end3}
                                                                        >
                                    <Box className='servBox servBox1'>
                                        <Box className='servBoxNum'>
                                            <OurTeamIcon1 />
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                150+
                                            </span>
                                            <span className='servTxt'>
                                                {t('teamCol1')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                                <Col className='servBoxCol'>
                                <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={1.6}
                                                                            start={start3}
                                                                            end={end3}
                                                                        >
                                    <Box className='servBox servBox2'>
                                        <Box className='servBoxNum'>
                                            <OurTeamIcon2 />
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                25+
                                            </span>
                                            <span className='servTxt'>
                                                {t('teamCol2')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                                <Col className='servBoxCol'>
                                <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={2}
                                                                            start={start3}
                                                                            end={end3}
                                                                        >
                                    <Box className='servBox servBox3'>
                                        <Box className='servBoxNum'>
                                            <OurTeamIcon3 />
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                50+
                                            </span>
                                            <span className='servTxt'>
                                                {t('teamCol3')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                                <Col className='servBoxCol'>
                                <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={2.4}
                                                                            start={start3}
                                                                            end={end3}
                                                                        >
                                    <Box className='servBox servBox4'>
                                        <Box className='servBoxNum'>
                                            <OurTeamIcon4 />
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                30+
                                            </span>
                                            <span className='servTxt'>
                                                {t('teamCol4')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                                <Col className='servBoxCol'>
                                <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={2.6}
                                                                            start={start3}
                                                                            end={end3}
                                                                        >
                                    <Box className='servBox servBox4'>
                                        <Box className='servBoxNum'>
                                            <OurTeamIcon5 />
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle zero'>
                                                {t('zero')}
                                            </span>
                                            <span className='servTxt'>
                                                {t('teamCol5')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                            </Row>
                        </Col>

                    </Box>
                </Container>
            </TeamWapper>
            
            
        </>
    )
}
const TeamWapper = styled.section`
    padding-bottom: 60px;
    padding-top: 80px;
    background-image: url(${OutTeamBg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .projH{
        text-align: left;
        padding-bottom: 20px;
    }
    .projDescRow{
        align-items: center;
    }
    
    & > .container{
        .transformRow{
            margin-left: 0;
            margin-right: 0;
        }
        .transformColMain{
            position: relative;
            display: flex;
            align-items: center;
            height: 395px;
            padding-left: 650px;
            
            .transformContent{
                display: flex;
                width: 545px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-left: 0;
                
            }
            .ceoImg{
                position: absolute;
                left: 130px;
                bottom: 0px;
            }
        }
        
    }
    .main-heading-about{
        display: inline-block;
        span{
            color: var(--text);
            display: unset;
            font-size: 40px;
            font-family: var(--semibold);
            &.servicesT1{
                color: var(--white);
            }
        }
    }
    .servicesColMain{
        margin-bottom: 60px;
    }
    .servBox{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        flex-direction: column;
        border-radius: 8px;
        padding: 40px 20px;
        gap: 15px;
        height: 100%;
        background-color: var(--text);
    }
    .servBoxNum{
        display: flex;
        width: 64px;
        min-width: 64px;
        height: 64px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.3);
        color: var(--white);
        font-size: 24px;
        font-weight: 600;
    }
    
    .servBoxCol{
        margin-bottom: 20px;
        display: flex;
        max-width: 20%;
        min-width: 20%;
    }
    .servBoxContWrap{
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        
        & > *{
            width: 100%;
            color: var(--white);
        }
        span.servTitle{
            direction: ltr;
            font-family: var(--familyRbt);
            font-weight: 800;
            font-size: 45px;
            margin-bottom: 5px;
            text-align: center;
        }
        span.servTxt{
            font-family: var(--familyRbt);
            font-weight: 500;
            font-size: 16px;
            line-height: 27px;
            text-align: center;
        }
    }
    .primary-heading{
        padding-left: 600px;
    }
    .main-heading-about{
        span{
            font-family: var(--familyRbt);
            font-size: 40px;
            font-weight: var(--semiBold);
            
        }
    }
    .about-h-row{
            padding-right: 200px;
        }
        .servBoxCol > div{
            width: 100%;
            min-width: 100%;
        }
    body.rtl &{
        .projH{
            text-align: right;
        }
        .projTxt{
            font-size: 36px;
        }
        & > .container{
            /* .transformRow{
                margin-left: 0;
                margin-right: 0;
            } */
            .transformColMain{
                padding-left: calc(var(--bs-gutter-x) * .5);
                padding-right: 650px;
                
                .transformContent{
                    width: 545px;
                    /* padding-left: 0;
                    padding-right: 0; */
                    
                }
                .ceoImg{
                    position: absolute;
                    left: auto;
                    right: 130px;
                }
            }
            
        }
        .main-heading-about{
            display: inline-block;
            span{
                display: unset;
                font-size: 40px;
                font-family: var(--arSemiBold);
            }
        }
        .zero{
            font-size: 45px;
            font-family: var(--arBold);
        }
        span.servTxt{
            font-family: var(--arMedium);
            
        }
        
        .primary-heading{
            text-align: left;
            padding-left: 0;
        }
        .about-h-row{
            padding-right: 0;
            padding-left: 200px;
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            .transformColMain{
                padding-left: 550px;
                .transformContent{
                    /* width: 545px; */
                }
                .ceoImg{
                    left: 0;
                }
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding-right: 550px;
                    
                    .ceoImg{
                        right: 0;
                    }
                }
                
            }
        }
        
    }
    @media (max-width: 1199px) {
        & > .container{
            .transformColMain{
                padding-left: 500px;
                .transformContent{
                    width: 450px;
                }
                .ceoImg{
                    left: 0;
                }
            }
            
        }
         .primary-heading{
            padding-left: 450px;
        }
        .about-h-row{
            padding-right: 0px;
        }
        body.rtl &{
            
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .transformColMain{
                padding: 0;
                .transformContent{
                    width: 100%;
                    padding: 0px 20px 0 20px;
                }
                .ceoImg{
                    display: none;
                }
            }
            
        }
        .primary-heading{
            padding-left: 0px;
        }
        .main-heading-about{
            line-height: 1.1;
            span{
                font-size: 30px;
            }
            
        }
        .servBoxCol{
            width: 50%;
            min-width: 50%;
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding: 0;
                    .transformContent{
                        width: 100%;
                        padding: 0px 20px 0 20px;
                    }
                    .ceoImg{
                        display: none;
                    }
                }
                
            }
            .primary-heading{
                text-align: right;
            }
            .about-h-row{
                padding-right: 0;
                padding-left: 0;
                
            }
            .main-heading-about{
                span{
                    font-size: 30px;
                    
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .transformColMain{
                height: auto;
                padding-top: 50px !important;
                padding-bottom: 50px !important;
                .transformContent{
                    width: 100%;
                    padding-left: 5px;
                    padding-right: 5px;
                    .transformTxt{
                        font-size: 18px;
                    }
                }
                
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    .transformContent{
                        padding-left: 5px;
                        padding-right: 5px;
                    }
                    
                }
                
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        .servBoxCol{
            width: 100%;
            min-width: 100%;
        }
    }
    @media (max-width: 350px) {
        
    }
`

const ProjWapper = styled.section`
    .projColImg{
        padding: 0;
    }
    .projImg{
        span{
            width: 100%;
            img{
                width: 100%;
            }
        }
    }
`

export default Team
